import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../api/client';

function Login({ setToken }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await client.post('/auth/login', { email, password });
            setToken(response.data.token);
        } catch (err) {
            console.error("Login Error:", err);
            const errorMessage = err.response?.data?.message || err.message || 'Login failed';
            setError(`Error: ${errorMessage}`);
        }
    };

    return (
        <div className="card" style={{ maxWidth: '400px', margin: '50px auto' }}>
            <h2>Login</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Login</button>
            </form>
            <p>
                Don't have an account? <Link to="/register" style={{ color: 'var(--secondary-color)' }}>Register</Link>
            </p>
        </div>
    );
}

export default Login;
